var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-main',{staticClass:"login"},[_c('v-container',{staticClass:"mx-auto my-auto",staticStyle:{"width":"100px"}},[_c('v-progress-circular',{attrs:{"size":100,"width":7,"color":"blue","indeterminate":""}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }